import { ModalContext } from "contexts/ModalContext";
import { PriorityModalContext } from "contexts/PriorityModalContext";
import { useContext } from "react";
import { HiCheckCircle } from "react-icons/hi";
import { LuCog, LuPencil } from "react-icons/lu";
import { TbPencil, TbPencilBolt, TbPencilCheck } from "react-icons/tb";
import useConfigPanel from "utils/hooks/useConfigPanel";

const { Button, Dropdown, Tooltip } = require("components/ui");
const { Trans } = require("react-i18next");

const ConfigPanelImageTypes = ({
    config,
    setConfig,
    template = "",
    className = "",
    parentClassName = "",
    placement = "bottom-start"
}) => {

    const { openModalPriority } = useContext(PriorityModalContext);
    const { imageTypes } = useConfigPanel(template, config?.postType);
    const selectedType = imageTypes?.filter(e => e.value == config?.imageType)?.[0] || imageTypes[0];

    if (!imageTypes?.length) return <></>;

    return (
        <Dropdown
            menuClass="max-h-[250px] w-[240px] overflow-y-auto !rounded-2xl !border-0 !p-0"
            placement={placement}
            parentClassName={parentClassName}
            renderTitle={
                <div className={`cursor-pointer w-full !pl-5 overflow-hidden whitespace-nowrap !pr-5 !py-3 !h-auto bg-gray-50 dark:bg-gray-600 rounded-2xl flex ${!!selectedType?.configComponent ? `!justify-start` : `justify-center`} gap-2 items-center font-semibold ${className}`} >
                    {!!selectedType?.emoji &&
                        <>{selectedType?.emoji}</>
                    }
                    {selectedType?.name}

                    {!!selectedType?.configComponent && 
                        <Tooltip title={selectedType?.tooltip}>
                            <selectedType.ConfigIcon 
                                onClick={(e) => { e.stopPropagation(); openModalPriority(selectedType.configComponent, 900) }} 
                                className="text-lg ml-1" 
                            />
                        </Tooltip>
                    }
                </div>
            }
        >
            {imageTypes?.map((_imageType, key) => (
                <Dropdown.Item key={key} className="!px-0">
                    <div onClick={() => setConfig({...config, imageType: _imageType?.value })} className="flex justify-between items-center gap-2 !px-4 !py-2 cursor-pointer dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-600 w-full">
                        <div className='flex items-center gap-2'>
                            {_imageType?.emoji}
                            {_imageType?.name}
                        </div>
                        <HiCheckCircle className={`text-xl text-primary-600 shrink-0 ${_imageType?.value != config?.imageType && `opacity-[0.1]`}`} />
                    </div>
                </Dropdown.Item>
            ))}
        </Dropdown>
    );
}

export default ConfigPanelImageTypes;